export default __webpack_public_path__ + "static/media/minus_gray.72ec2946.svg";